import {useCallback} from 'react'
import {useResourceContext, useUpdateMany} from 'react-admin'
import {useNavigate} from 'react-router-dom'

const useSoftDelete = ({
  ids,
  onError,
  onSuccess: onUpdateSuccess,
  redirectTo,
  resource: r,
}: UseSoftDeleteProps) => {
  const navigate = useNavigate()
  let resource = useResourceContext()
  resource = r ?? resource
  const onSuccess = useCallback(() => {
    navigate(redirectTo ?? `/${resource}`, {replace: true})
    onUpdateSuccess?.()
  }, [redirectTo, resource, navigate, onUpdateSuccess])
  const [updateMany] = useUpdateMany(
    resource, {data: {isDeleted: true}, ids: ids}, {onError, onSuccess}
  )
  return updateMany
}

interface UseSoftDeleteProps {
  ids: string[]
  onError?: (...props: any) => void
  onSuccess?: VoidFunction
  redirectTo?: string
  resource?: string
}

export default useSoftDelete
